import {componentsHelper} from './_helper'

export default [
  {
    path: '/terms-and-conditions/business',
    ...componentsHelper('conditions/business')
  },
  {
    path: '/terms-and-conditions/delivery',
    ...componentsHelper('conditions/delivery')
  }
]



// WEBPACK FOOTER //
// ./client/router/conditions.js